// extracted by mini-css-extract-plugin
export default {"loader":"Cvt9djRE","mltShdSpin":"CilZ2DEa","round":"qVE1MgAv"};